import { SAVE_SELECTED_DEVICE } from './actionTypes';

export function saveSelectedDevice(deviceId) {
    return { type: SAVE_SELECTED_DEVICE, selectedDeviceId: deviceId };
}